// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__y7NqA","title":"styles_title__-Fa4h","description":"styles_description__Hr5V5","bone-skeleton":"styles_bone-skeleton__WmIAH"};